import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import styled from 'styled-components';
import { MonthBtn } from '../../common/styles';

const MonthFilter = ({
  currentMonthSelected,
  lastMonthSelected,
  setCurrentMonthSelected,
  setLastMonthSelected,
}) => {
  const MonthFilterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    cursor: pointer;
  `;

  const handleCurrentMonthClick = () => {
    setCurrentMonthSelected(true);
    setLastMonthSelected(false);
  };

  const handleLasttMonthClick = () => {
    setCurrentMonthSelected(false);
    setLastMonthSelected(true);
  };

  return (
    <MonthFilterWrapper>
      {' '}
      <MonthBtn active={currentMonthSelected} onClick={handleCurrentMonthClick}>
        This month
      </MonthBtn>{' '}
      <MonthBtn active={lastMonthSelected} onClick={handleLasttMonthClick}>
        {' '}
        Last month{' '}
      </MonthBtn>{' '}
    </MonthFilterWrapper>
  );
};

MonthFilter.propTypes = {
  currentMonthSelected: PropTypes.bool,
  lastMonthSelected: PropTypes.bool,
  setCurrentMonthSelected: PropTypes.func,
  setLastMonthSelected: PropTypes.func,
};

MonthFilter.defaultProps = {
  currentMonthSelected: false,
  lastMonthSelected: false,
  setCurrentMonthSelected: _noop,
  setLastMonthSelected: _noop,
};

export default MonthFilter;
